export const isStickyGamesBtnShown = 'isStickyGamesBtnShown';
